import React, { useMemo } from "react";
import { arc } from "d3-shape";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

import allocationIcon from "../../../theme/assets/svg/b_cabinet_partners_allocation_icon.svg";
import {useDispatch} from "react-redux";
import {setCabinetPartnersPointsHistoryModalStatus} from "../../../store/cabinet/action";

const RADIUS = 72;
const RING_WIDTH = 24; // толщина кольца (было stroke-width: 2.4rem)
const CORNER_RADIUS = 3; // радиус скругления углов сегмента — крутится отдельно от толщины
const GAP_ANGLE = 0.05; // зазор между сегментами, в радианах

const formatAmount = (value) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "0";

    return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(numberValue);
};

const CabinetPartnersAllocation = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();


    const allocationData = [
        {
            id: "first",
            label: t("С депозитов"),
            value: 100000000,
            currency: "USDT",
            color: "#FF3500",
        },
        {
            id: "second",
            label: t("С депозитов"),
            value: 400000000,
            currency: "USDT",
            color: "#FFAD14",
        },
    ];

    const total = useMemo(() => {
        return allocationData.reduce((sum, item) => sum + Number(item.value || 0), 0);
    }, [allocationData]);

    const chartItems = useMemo(() => {
        const innerRadius = RADIUS - RING_WIDTH / 2;
        const outerRadius = RADIUS + RING_WIDTH / 2;

        const arcGenerator = arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .cornerRadius(CORNER_RADIUS);

        let angleOffset = 0;

        return allocationData.map((item) => {
            const percent = total > 0 ? item.value / total : 0;
            const fullAngle = percent * Math.PI * 2;

            const startAngle = angleOffset + GAP_ANGLE / 2;
            const endAngle = angleOffset + Math.max(fullAngle - GAP_ANGLE / 2, 0);

            angleOffset += fullAngle;

            return {
                ...item,
                path: arcGenerator({ startAngle, endAngle }),
            };
        });
    }, [allocationData, total]);

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.titleIcon}>
                        <img src={allocationIcon} alt="" />
                    </div>

                    <div className={Styles.titleTextWrap}>
                        <div className={Styles.title}>
                            {t("Баланс баллов")}:
                        </div>

                        <div className={Styles.subtitle}>
                            {t("Обзор баллов")}
                        </div>
                    </div>
                    <div className={Styles.historyBtn} onClick={()=>{dispatch(setCabinetPartnersPointsHistoryModalStatus(true))}}>
                        {t("История")}
                    </div>
                </div>

                <div className={Styles.chartWrap}>
                    <svg className={Styles.chart} viewBox="-90 -90 180 180">
                        <circle
                            className={Styles.chartTrack}
                            cx="0"
                            cy="0"
                            r={RADIUS}
                        />

                        {chartItems.map((item) => (
                            <path
                                key={item.id}
                                className={Styles.chartSegment}
                                d={item.path}
                                fill={item.color}
                            />
                        ))}
                    </svg>

                    <div className={Styles.chartCenter}>
                        <div className={Styles.chartCenterLabel}>
                            {t("Всего")}:
                        </div>

                        <div className={Styles.chartCenterValue}>
                            {formatAmount(total)}
                        </div>

                        <div className={Styles.chartCenterCurrency}>
                            {t('Баллов')}
                        </div>
                    </div>
                </div>

                <div className={Styles.legendWrap}>
                    {allocationData.map((item) => (
                        <div className={Styles.legendRow} key={item.id}>
                            <div
                                className={Styles.legendDot}
                                style={{ backgroundColor: item.color }}
                            />

                            <div className={Styles.legendLabel}>
                                {item.label}
                            </div>

                            <div
                                className={Styles.legendValue}
                                style={{ borderColor: item.color }}
                            >
                                {formatAmount(item.value)} {t('Баллов')}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CabinetPartnersAllocation;